module.exports = __webpack_public_path__ + "img/profile-picture-avatar.3187887f.jpg";